import { MijnRoute } from '../../mijn-navigatie.model';

export const PERSONAL_LOAN_VIEW: MijnRoute = {
    path: ':id',
    navigationEvent: 'toPersoonlijkeLening',
    regex: /^\/persoonlijke-lening\/[^/]+$/,
    webcomponent: 'mijn-persoonlijke-lening-webcomponent'
};
